import React, {useRef} from 'react';
import {Dialog, DialogContent, DialogTitle, IconButton, Tooltip} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PDFViewer from '../../../../components/ocr-batch/PDFViewer';
import ImageViewer from '../ImageViewer'
import {useObjectUrl} from '../../../../hooks/useObjectUrl';
import {useTranslation} from "react-i18next";

interface FilePreviewDialogProps {
    file: File | null;
    onClose: () => void;
}

const FilePreviewDialog = ({file, onClose}: FilePreviewDialogProps) => {
    const previewUrl = useObjectUrl(file);
    const { t } = useTranslation();

    // remember last file - reference will be updated when file !== null
    const lastFileRef = useRef<File | null>(null);
    if (file !== null) {
        lastFileRef.current = file;
    }

    const displayFile = file ?? lastFileRef.current;

    return (
        <Dialog
            open={!!file}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            sx={{ overflow: 'auto', height: '100%' }}
            PaperProps={{
                sx: {
                    width: '800px',
                    height: '90vh',
                    maxWidth: '800px',
                }
            }}
            aria-labelledby="file-preview-dialog-title"
            aria-modal="true"
        >
            <DialogTitle
                id="file-preview-dialog-title"
                sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
            >
                {displayFile?.name ?? t('ocr.label.previewFile')}

                <Tooltip title={t('ocr.button.close')}>
                    <IconButton onClick={onClose}
                                size="small"
                                color='secondary'
                                aria-label={t('ocr.button.close') as string}>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </DialogTitle>

            <DialogContent>
                {displayFile?.type === 'application/pdf' ? (
                    <PDFViewer previewUrl={previewUrl} fileName={displayFile.name} />
                ) : (
                    <ImageViewer previewUrl={previewUrl} fileName={displayFile?.name || ''} />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default FilePreviewDialog;